module.exports = __webpack_public_path__ + "static/media/balconyCleaning.a5fe36ba.png";